<div id="sistemazioni">
  <ng-container *ngFor="let day of days; let index = index">
    <app-hotels [day]="day" [showOptionlServices]="showOptionlServices" [noImageUrl]="noImageUrl"
      [defaultImage]="defaultImage"
      [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
      [hideMedia]="hideMedia"
      [serviceIcons]="serviceIcons"></app-hotels> <!-- *ngIf="IsFirstTimeHotel(index)" -->
  </ng-container>
</div>
